// src/components/trial/lp/trial-beta/assets.ts
// The attachment inlined every asset as base64 under an /assets/... path that does not exist in
// this repo. This maps each one to its real path: reused where the repo already had the file,
// extracted into /assets/images/trial-beta/ where it did not.
export const TRIAL_BETA_ASSETS = Object.freeze({
  gameCs2: '/images/CS2.webp',
  gameDota2: '/images/Dota2.webp',
  gameFortnite: '/images/Fortnite.webp',
  gameValorant: '/images/Valorant.webp',
  gameApex: '/images/games/apex.webp',
  gameLol: '/images/games/lol.webp',
  gameWow: '/images/games/wow.webp',
  gameFfxiv: '/assets/games-new/ffxiv.webp',
  coverCs2: '/assets/images/trial-beta/game-cs2-official.webp',
  coverValorant: '/assets/images/trial-beta/game-valorant-official.webp',
  coverDota2: '/assets/images/trial-beta/game-dota2-official.webp',
  coverFortnite: '/assets/images/trial-beta/game-fortnite-official.webp',
  clientLibrary: '/assets/images/trial-beta/p1-client-library.webp',
  clientRoute: '/assets/images/trial-beta/p1-client-route.webp',
  clientConnected: '/assets/images/trial-beta/p1-client-connected.webp',
  clientTraffic: '/assets/images/trial-beta/p1-client-traffic.webp',
  // The multiconnection game node (attachment line 2734). Extracted from the attachment's own
  // manifest with scripts/extract-trial-beta-assets.cjs — Task 2 left it uncopied because no
  // section needed it yet. Its poster is the Fortnite cover already mapped above as `gameFortnite`.
  gameplayLoop: '/assets/video/fortnite-gameplay-loop.mp4',
  clientVideo: '/assets/video/fortnite-noping-client.mp4',
  clientVideoPoster: '/assets/video/fortnite-noping-client-poster.webp',
} as const);
